import type { RouteRecordRaw } from "vue-router";

const router: RouteRecordRaw[] = [
  {
    path: "/data/import/",
    name: "LISADataImport",
    children: [
      {
        path: "",
        name: "LISADataImportList",
        component: () => import("./views/LISAImportList.vue"),
        meta: {
          rights: ["import.read"],
        },
      },
      {
        path: "create",
        name: "LISADataImportCreate",
        component: () => import("./views/LISAImportCreate.vue"),
        props: (route) => {
          const queryValue = Array.isArray(route.query.siteId)
            ? route.query.siteId[0]
            : route.query.siteId;
          const siteId = queryValue == null ? undefined : Number(queryValue);
          return {
            siteId: Number.isInteger(siteId) ? siteId : undefined,
          };
        },
        meta: {
          rights: ["import.write"],
        },
      },
      {
        path: ":id",
        name: "LISADataImportUpdate",
        component: () => import("./views/LISAImportUpdate.vue"),
        props: (p) => ({ id: Number(p.params.id) }),
        meta: {
          rights: ["import.write"],
        },
      },
    ],
  },
];
export default router;
